import { render, staticRenderFns } from "./phindex1.vue?vue&type=template&id=7f19ce13&scoped=true"
import script from "./phindex1.vue?vue&type=script&lang=js"
export * from "./phindex1.vue?vue&type=script&lang=js"
import style0 from "./phindex1.vue?vue&type=style&index=0&id=7f19ce13&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f19ce13",
  null
  
)

export default component.exports